import { render, staticRenderFns } from "./SelectPresetDialog.vue?vue&type=template&id=ba64b1b2&scoped=true"
import script from "./SelectPresetDialog.vue?vue&type=script&lang=js"
export * from "./SelectPresetDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectPresetDialog.vue?vue&type=style&index=0&id=ba64b1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba64b1b2",
  null
  
)

export default component.exports